// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../shared/components/editable-field';
import FileAttachmentSinglePanel from '../../../claim/shared/components/file-attachment-single-panel';
import {FormattedMessage} from 'react-intl';
import FormattedNumberInput from '../../../shared/components/formatted-number-input';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import WarrantyDatePicker from '../../../shared/components/warranty-date-picker';
import {buildDate} from '../../../shared/services/build-date';
import moment from 'moment';

function handleEffectiveDateChange(date) {

    this.actions.updateEffectiveDate(date.valueOf());

    if (!this.tcsm && this.laborRate.effectiveDate !== date.valueOf()) {

        this.actions.updateIsSubmitDisabled(false);

    }

}

function handleFileUpload(file, dropzone) {

    this.actions.addFile(JSON.parse(file.xhr.response));
    dropzone.removeFile(file);

}

function handleFileDelete(file) {

    this.actions.deleteFile(file);

}

function handleAverageTechPayRateChange(rate) {

    const updatedRate = rate ?
        parseFloat(rate) :
        null;

    this.actions.updateAverageTechPayRate(updatedRate);

}

const AdditionalFields = props =>
    <section className='additional-fields'>
        <label className='effective-date'>
            <FormattedMessage id='EFFECTIVE_DATE'/>
            <EditableField
                isEditable={!props.tcsm}
                value={buildDate(props.laborRate.effectiveDate)}
            >
                <WarrantyDatePicker
                    maxDate={moment().add(365, 'days')}
                    minDate={moment().add(14, 'days')}
                    onChange={props::handleEffectiveDateChange}
                    selected={moment.utc(props.laborRate.effectiveDate)}
                />
            </EditableField>
        </label>
        <label className='average-tech-pay-rate'>
            <FormattedMessage id='AVERAGE_TECH_PAY_RATE'/>
            <EditableField
                isEditable={!props.tcsm}
                value={props.laborRate.averageTechPayRate}
            >
                <FormattedNumberInput
                    allowNegative={false}
                    decimalPrecision={2}
                    isValidInput={value => value < 10000000}
                    onValueChange={handleAverageTechPayRateChange.bind(props)}
                    value={props.laborRate.averageTechPayRate}
                />
            </EditableField>
        </label>
        {props.tcsm &&
        <label className='requested-by'>
            <FormattedMessage id='REQUESTED_BY'/>
            <span>{props.laborRate.requestedBy.buildUserName() || <FormattedMessage id='NO_USER_FOUND'/>}</span>
        </label>
        }
        <section className='extra-fields'>
            {props.children}
        </section>
        {!props.tcsm &&
        <section className='file-upload'>
            <label>
                <FormattedMessage id='UPLOAD_DOCUMENT'/>
            </label>
            <FileAttachmentSinglePanel
                displayMessage='FILE_UPLOAD_MESSAGE_SINGLE'
                djsConfig={{maxFiles: 1}}
                file={props.laborRate.file}
                isRequired={false}
                isUploadAllowed={!props.tcsm}
                onFileDelete={props::handleFileDelete}
                onFileUploadSuccess={props::handleFileUpload}
                serviceConfig={{
                    className: 'ZWY_SV_LABRATREQ',
                    classType: 'OT',
                    objectKey: `${props.laborRate.account}${moment.utc().format('YYYYMMDD')}`
                }}
            />
        </section>}
    </section>;

AdditionalFields.displayName = 'AdditionalFields';
AdditionalFields.propTypes = {
    actions: PropTypes.object.isRequired,
    children: PropTypes.node,
    laborRate: PropTypes.instanceOf(LaborRate).isRequired,
    tcsm: PropTypes.bool.isRequired
};

export default AdditionalFields;



// WEBPACK FOOTER //
// ./src/claim/labor-rate-change/components/additional-fields.js